/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Save_Settings_LabelInputs */



/**
* | output |
* | --- |
* | "Save general settings" |
*
* @param {Options_General_Save_Settings_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_save_settings_label = /** @type {((inputs?: Options_General_Save_Settings_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Save_Settings_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les paramètres généraux")
	if (locale === "de") return /** @type {LocalizedString} */ ("Allgemeine Einstellungen speichern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salva le impostazioni generali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохраните общие настройки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardar configuración general")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("保存常规设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一般設定を保存する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सामान्य सेटिंग्स सहेजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvar configurações gerais")
	return /** @type {LocalizedString} */ ("Save general settings")
});